import React from "react"
import autobind from "class-autobind"
import { RaisedButton, Popover, Checkbox } from "material-ui"
import FinddDatePicker from "../common/FinddDatePicker"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
import AccountStore from "../../stores/AccountStore"
import strings from "../../localization/strings"
import { blueGrey500 } from "material-ui/styles/colors"
import moment from "moment"
import * as reportActions from "../../actions/ReportAction"
interface IProps {

}
interface IState {
    showDownloadMenu: boolean
    startDate: Date
    endDate: Date
    restrictDate: boolean
    anchorEl?: any
}

export default class HierarchyRecordPunchExport extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            showDownloadMenu: false,
            startDate: moment().startOf("month").startOf("day").toDate(),
            endDate: new Date(),
            restrictDate: false
        }
        autobind(this)
    }

    getDatesMenu(event) {
        this.setState({
            showDownloadMenu: true,
            anchorEl: event.currentTarget
        })
    }

    hideDownloadMenu() {
        this.setState({ showDownloadMenu: false })
    }

    downloadPDF() {
        this.hideDownloadMenu()
        reportActions.downloadHierarchyPunchReport(
            AccountStore.getCurrentAccount().Id,
            HierarchySettingsStore.getGlobalLevelItemFilterId(),
            moment(this.state.startDate).utc(true).format(),
            moment(this.state.endDate).utc(true).format(),
            this.state.restrictDate
        )
    }

    render() {
        return (
            <div style={{ position: "absolute", right: 20, top: -48 }}>
                <RaisedButton
                    data-intercom-target={"menu-Hierarchy-Records-PunchExport-Btn-OpenHierarchyPunchReportPopover"}
                    onTouchTap={this.getDatesMenu}
                    icon={<i className="fa fa-download" />}
                    label={strings.Hierarchy_Punch_Report}
                />
                <Popover
                    open={this.state.showDownloadMenu}
                    anchorEl={this.state.anchorEl}
                    anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
                    targetOrigin={{ horizontal: "left", vertical: "top" }}
                    style={{ width: 300 }}
                    onRequestClose={this.hideDownloadMenu}
                >
                    <div style={{ padding: 10, textAlign: "center" }}>
                        <h3>{strings.Hierarchy_Punch_Report}</h3>
                        <FinddDatePicker
                            data-intercom-target={"menu-Hierarchy-Records-PunchExport-Popover-Select-StartDate"}
                            floatingLabelText={strings.Start_Date}
                            autoOk={true}
                            value={moment(this.state.startDate).toDate()}
                            onChange={(_, date) => this.setState({ startDate: date })}
                            container="inline"
                            cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
                            firstDayOfWeek={0}
                        />
                        <FinddDatePicker
                            data-intercom-target={"menu-Hierarchy-Records-PunchExport-Popover-Select-EndDate"}
                            floatingLabelText={strings.End_Date}
                            autoOk={true}
                            value={moment(this.state.endDate).toDate()}
                            onChange={(_, date) => this.setState({ endDate: date })}
                            container="inline"
                            cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
                            firstDayOfWeek={0}
                        />
                        <Checkbox
                            data-intercom-target={"menu-Hierarchy-Records-PunchExport-Popover-Check-RestrictToDates"}
                            label={strings.Restrict_To_Dates}
                            checked={this.state.restrictDate}
                            style={{ marginTop: 10 }}
                            onCheck={(obj, checked) => this.setState({ restrictDate: checked })}
                        />
                        <div style={{ padding: 20 }}>
                            <RaisedButton
                                data-intercom-target={"menu-Hierarchy-Records-PunchExport-Popover-Btn-DownloadPDF"}
                                secondary
                                label={strings.Download_PDF}
                                icon={<i className="fa fa-file-pdf-o" style={{ color: "#ffffff" }} />}
                                onTouchTap={this.downloadPDF}
                            />
                        </div>
                    </div>
                </Popover>
            </div>
        )
    }
}
